module.exports = __webpack_public_path__ + "static/img/ic_gy_fw_zq.40ca36de.png";